"use client";

import React, { useContext } from 'react';
import Button from '../../button';
import { convertLegacyProps } from '../../button/buttonHelpers';
import { ModalContext } from '../context';
const NormalOkBtn = () => {
  const _useContext = useContext(ModalContext),
    confirmLoading = _useContext.confirmLoading,
    okButtonProps = _useContext.okButtonProps,
    okType = _useContext.okType,
    okTextLocale = _useContext.okTextLocale,
    onOk = _useContext.onOk;
  return /*#__PURE__*/React.createElement(Button, Object.assign({}, convertLegacyProps(okType), {
    loading: confirmLoading,
    onClick: onOk
  }, okButtonProps), okTextLocale);
};
export default NormalOkBtn;